








































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import DateUtils from '@/common/js/DateUtils'
import Enums from '@/lib/enums'
import { routers } from '@/router/router'
import QRcode from 'qrcodejs2'


class rechargeInput {
    type: number;
    amount: number;
    constructor() {
        this.amount = null;
        this.type = 0;
    }
}
class confirmPaymentInput {
    type: number;
    tradeNo: string;
}

@Component({
    name:"recharge",
})
export default class Recharge extends AbpBase {
    rechargeInput: rechargeInput = new rechargeInput();
    paymentChannelType = Enums.getEnum(Enums.PaymentChannelType, false);
    amountList: Array<number> = [50, 100, 200, 300];
    rechargeLoding: Boolean = false;
    confirmPaymentInput: confirmPaymentInput = new confirmPaymentInput();
    confirmPaymentLoding: Boolean = false;
    logImg: string = '';
    isEmpty(rule, value, callback) {
    if (value == null || value == undefined || value == "") {
      callback(new Error('金额不能为空！'))
    } else {
      callback();
         }
    }

    rechargeInline= {
        amount: [
              {required:true , type:'number' , message: '充值金额不能为空', trigger: 'blur', validator: this.isEmpty}
        ]
    };

    confirmPaymentInline= {
        tradeNo: [
              {required:true , max:100, min:20 , message: '订单编号不能为空，且在20-100之间', trigger: 'blur'}
        ]
    };

    setQrCode() {
        var type = this.rechargeInput.type;
        this.logImg = Enums.PaymentChannelType.filter(function (item) { return item.value == type })[0].logo;

                let qrcode = new QRcode('qrcode', {
                     width: 300,
                     height: 300, // 高度
                    text: this.$store.state.fontamount.paymentUrl, // 二维码内容
                 });
    }

    async confirmPayment() {
        (this.$refs.confirmPaymentform as any).validate(async (valid:boolean)=>{
             if (valid) {
                 this.confirmPaymentLoding = true;
                await this.$store.dispatch({
                    type: 'fontamount/confirmPayment',
                    data: this.confirmPaymentInput
                }).finally(() => {
                       this.confirmPaymentLoding = false;
                });
                this.$Message.success('充值确认成功，积分已到账。');
            }
        })
    }

    async createRecharge() {
        //this.$Message.info({
        //    content: '支付接口升级，充值请联系客户线下充值。',
        //    closable: true,
        //    duration:3600
        //});
        //return;
        (this.$refs.rechargeform as any).validate(async (valid:boolean)=>{
             if (valid) {
                this.rechargeLoding = true;
                await this.$store.dispatch({
                    type:'fontamount/generatePaymentUrl',
                    data: this.rechargeInput
                }).finally(() => {
                       this.rechargeLoding = false;
                });
                this.confirmPaymentInput.type = this.rechargeInput.type;
                this.setQrCode();
            }
        })
    }
}
